import moment from 'moment';

export const isExpiredDate = (origin: Date, destination: Date): boolean => {
  const diff = moment(origin).diff(destination, 'days');

  return diff < 0;
};

export const createAccountBrazilianDateToDBDate = (date: string): string =>
  moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
